/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { indexSingles, removeMediumFromSingle } from "../../../../../api/sound_tracks";
import { Spinner } from "react-bootstrap";
import { log_error } from "../../../../../api";

export default ({ show, hide, removeMedium }) => {

  let [loading, setLoading] = useState(false)

  const handleSinglesRemove = () => {
    try {
      setLoading(true)
      removeMedium()
    } catch (error) {
      console.log(log_error(error))
    } finally {
      setLoading(false)
    }
  };

  return (
    <Modal
      className="unsubscribe-primo-modal"
      show={show}
      onHide={hide}
      animation={true}
    >
      <Modal.Body className="text-center p-4 m-3">
        <p className="text-uppercase">
          {`Are you sure you want to delete this single?`}
        </p>
        <small>Deleting a single is permanent, but you can re-add it later if you'd like.</small>
        <div className="d-flex justify-content-center mt-3">
          <button
            onClick={hide}
            type="reset"
            className="btn btn-outline-primary btn-md mr-3"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary btn-md"
            onClick={handleSinglesRemove}
          >
            {loading ? (
              <Spinner size="sm" animation="border" role="status" />
            ) : (
              "Yes"
            )}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
